import React from 'react';
import ProgressBar from '../ui/bars/ProgressBar';
import CustomActionButton from '../ui/buttons/CustomActionButton';
import RetirementProjectionChart from '../ui/charts/RetirementProjectionChart';
import CurrencyText from '../ui/labels/CurrencyText';

const DreamCard = ({ dream, onEdit, canEdit = true }) => {
  const progress = Math.min((dream.investedValue / dream.dreamValue) * 100, 100);
  const remainingMonths = dream.remainingMonths || 0;

  return (
    <div className="bg-white rounded-custom20 flex flex-col gap-4">
      <div className="flex flex-col bg-blueHighlight rounded-t-custom20">
        <div className="flex justify-between items-center px-6 py-4">
          <h3 className="text-white text-lg font-semibold">{dream.name}</h3>
          {canEdit && (
            <div className="flex gap-2">
              <CustomActionButton className="h-7" state="alt" onClick={() => onEdit(dream.id)}>
                EDITAR
              </CustomActionButton>
            </div>
          )}
        </div>
      </div>

      <div className="">
        <div className="px-6 flex flex-col gap-4 mb-6">
          <div className="text-base flex justify-between">
            <div className="flex items-baseline gap-1">
              <span className="text-blueMedium text-lg font-semibold">
                {new Date(dream.targetDate).toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' })}
              </span>
            </div>
            <div className="flex items-baseline gap-1">
              {dream.dreamType === 'withdrawal' ? (
                <>
                  <span className="text-redSoft text-lg font-semibold">-</span>
                </>
              ) : (
                <>
                  <span className="text-tealMedium text-lg font-semibold">+</span>
                </>
              )}
              <CurrencyText size="small" color="text-blueMedium" value={dream.dreamValue} />
            </div>
          </div>

          <div className="text-lg text-center text-tealBase">
            <span>
              Faltam <span className="font-semibold">{remainingMonths}</span> meses!
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DreamCard;
